import React from "react";

interface PreventPropagationProps {
  children: React.ReactNode;
  onClick?: (event: React.MouseEvent<HTMLSpanElement, MouseEvent>) => void;
  onChange?: (event: React.FormEvent<HTMLSpanElement>) => void;
}

function PreventPropagation({
  children,
  onClick = undefined,
  onChange = undefined,
}: PreventPropagationProps): React.JSX.Element {
  return (
     
    <span
      style={{ display: "contents" }}
      onClick={e => {
        e.stopPropagation();
        if (typeof onClick === "function") {
          onClick(e);
        }
      }}
      onChange={e => {
        e.stopPropagation();
        if (typeof onChange === "function") {
          onChange(e);
        }
      }}
    >
      {children}
    </span>
  );
}

export default PreventPropagation;
